import script from "./ListUserGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./ListUserGroup.vue?vue&type=script&setup=true&lang=js"

import "./ListUserGroup.vue?vue&type=style&index=0&id=088ea8ce&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-088ea8ce"]])

export default __exports__